import { Link } from "react-router-dom";
import SVG from "react-inlinesvg";

const PostRegisterOption = () => {

  return (
    <>
      <div className="main-wrapper onboarding-screens">
        <div className="cards-wrap card-success">
          <div className="card-body onboarding-model">
            <div className="header header-full-text">
              <div className="logo mb-4">
                <SVG
                  className="header-logo"
                  src="Assets/Images/Logos/kiddo.svg"
                  width="108"
                  height="32"
                />
              </div>
              <h1 className="title-medium text-center">Your account has been setup successfully.</h1>
              <p className="header-text text-start mb-4" style={{ fontWeight: "400", fontSize: "22px" }}>Let's add your patients to the watch list.</p>
            </div>
            <div className="card-inner create-account position-relative">
                <div className="btn-wrap btn-top-space">
                    <Link to={"/addpatientleads"} className="btn btn-success">
                        Add Patients
                    </Link>
                    </div>
                    <div className="btn-wrap btn-top-space">
                    <Link to={"/dashboard"} className="btn btn-success">
                        Go to Dashboard
                    </Link>
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostRegisterOption;
